import { IS_INSTANT_MOCK_MODE } from "./config"

export const IS_MOCK_MODE = IS_INSTANT_MOCK_MODE
export default IS_MOCK_MODE


